// // public/src/App.jsx (Updated)
// import React from "react";
// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import { motion, AnimatePresence } from "framer-motion";

// // Components
// import Navbar from "./components/Navbar";
// import Footer from "./components/Footer";

// // Pages
// import Homepage from "./pages/Homepage";
// import Services from "./pages/Services";
// import Projects from "./pages/Projects";
// import Team from "./pages/Team"; // Add this import
// import About from "./pages/About";
// import Contact from "./pages/Contact";
// import ServiceDetail from "./pages/ServiceDetail";
// import ProjectDetail from "./pages/ProjectDetail";
// import Blog from "./pages/Blog";
// import News from "./pages/News";
// import Gallery from "./pages/Gallery";

// // Styles
// import "./styles/agritech.css";
// import "./styles/pages.css";
// import "./styles/team.css"; // Add this import
// import BlogPost from "./pages/BlogPost";
// import NewsArticle from "./pages/NewsArticle";
// import Technology from "./pages/Technology";
// import Testimonials from "./pages/Testimonials";
// import TeamConsultancy from "./pages/TeamConsultancy";
// import TeamManagement from "./pages/TeamManagement";
// // import TeamAdvisory from "./pages/TeamAdvisory";
// import ClientPortal from "./pages/ClientPortal";
// import { ClientProvider } from './context/ClientContext';
// import ClientDashboard from "./pages/ClientDashboard";

// // Protected Route Component
// const ProtectedRoute = ({ children }) => {
//   const token = localStorage.getItem('agritech-client-token');
//   return token ? children : <ClientPortal />;
// };

// function App() {
//   return (
//     <ClientProvider>
//     <Router>
//       <div className="agritech-theme">
//         <Navbar />
//         <AnimatePresence mode="wait">
//           <Routes>
//             <Route path="/" element={<Homepage />} />
//             <Route path="/services" element={<Services />} />
//             <Route path="/services/:id" element={<ServiceDetail />} />
//             <Route path="/projects" element={<Projects />} />
//             <Route path="/projects/:id" element={<ProjectDetail />} />
//             <Route path="/team" element={<Team />} /> {/* Add this route */}
//             <Route path="/about" element={<About />} />
//             <Route path="/contact" element={<Contact />} />
//             <Route path="/blog" element={<Blog />} />
//             <Route path="/blog/:id" element={<BlogPost />} />{" "}
//             {/* You'll need to create this */}
//             <Route path="/news" element={<News />} />
//             <Route path="/news/:id" element={<NewsArticle />} />{" "}
//             {/* You'll need to create this */}
//             <Route path="/gallery" element={<Gallery />} />

//             <Route path="/technology" element={<Technology />} />
//             <Route path="/testimonials" element={<Testimonials />} />
//             <Route path="/team/consultancy" element={<TeamConsultancy />} />
//             <Route path="/team/management" element={<TeamManagement />} />
//             <Route path="/client-portal" element={<ClientPortal />} />
//             {/* <Route path="/team/advisory" element={<TeamAdvisory />} /> */}
//               <Route
//               path="/client/dashboard"
//               element={
//                 <ProtectedRoute>
//                   <ClientDashboard />
//                 </ProtectedRoute>
//               }
//             />
//           </Routes>
//         </AnimatePresence>
//         <Footer />
//       </div>
//     </Router>
//     </ClientProvider>
//   );
// }

// export default App;

// src/App.jsx (Updated with new client routes)
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

// Components
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

// Pages
import Homepage from "./pages/Homepage";
import Services from "./pages/Services";
import Projects from "./pages/Projects";
import Team from "./pages/Team";
import About from "./pages/About";
import Contact from "./pages/Contact";
import ServiceDetail from "./pages/ServiceDetail";
import ProjectDetail from "./pages/ProjectDetail";
import Blog from "./pages/Blog";
import News from "./pages/News";
import Gallery from "./pages/Gallery";
import BlogPost from "./pages/BlogPost";
import NewsArticle from "./pages/NewsArticle";
import Technology from "./pages/Technology";
import Testimonials from "./pages/Testimonials";
import TeamConsultancy from "./pages/TeamConsultancy";
import TeamManagement from "./pages/TeamManagement";
import ClientPortal from "./pages/ClientPortal";
import { ClientProvider } from "./context/ClientContext";
import ClientDashboard from "./pages/ClientDashboard";
import ClientProfile from "./pages/ClientProfile";
import ClientProjects from "./pages/ClientProjects";
import ClientReports from "./pages/ClientReports";
import ClientMessages from "./pages/ClientMessages";
import ClientAppointments from "./pages/ClientAppointments";

// Styles
import "./styles/agritech.css";
import "./styles/pages.css";
import "./styles/team.css";

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("agritech-client-token");
  return token ? children : <ClientPortal />;
};

function App() {
  return (
    <ClientProvider>
      <Router>
        <div className="agritech-theme">
          <Navbar />
          <AnimatePresence mode="wait">
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<Homepage />} />
              <Route path="/services" element={<Services />} />
              <Route path="/services/:id" element={<ServiceDetail />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/projects/:id" element={<ProjectDetail />} />
              <Route path="/team" element={<Team />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:id" element={<BlogPost />} />
              <Route path="/news" element={<News />} />
              <Route path="/news/:id" element={<NewsArticle />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/technology" element={<Technology />} />
              <Route path="/testimonials" element={<Testimonials />} />
              <Route path="/team/consultancy" element={<TeamConsultancy />} />
              <Route path="/team/management" element={<TeamManagement />} />
              <Route path="/client-portal" element={<ClientPortal />} />

              {/* Protected Client Routes */}
              <Route
                path="/client/dashboard"
                element={
                  <ProtectedRoute>
                    <ClientDashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/client/profile"
                element={
                  <ProtectedRoute>
                    <ClientProfile />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/client/projects"
                element={
                  <ProtectedRoute>
                    <ClientProjects />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/client/reports"
                element={
                  <ProtectedRoute>
                    <ClientReports />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/client/messages"
                element={
                  <ProtectedRoute>
                    <ClientMessages />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/client/appointments"
                element={
                  <ProtectedRoute>
                    <ClientAppointments />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </AnimatePresence>
          <Footer />
        </div>
      </Router>
    </ClientProvider>
  );
}

export default App;
